<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>采购管理</el-breadcrumb-item>
                <el-breadcrumb-item>采购到货 - (工厂下单后，录入工厂回货货品信息)</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-form label-width="90px" class="search-form">
            <el-row>
                <el-form-item label="关键词">
                    <el-col>
                        <el-input v-model="query.keyword" prefix-icon="Search" placeholder="单号/供应商/收货人" @keyup.enter="fetchs()"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="状态">
                    <el-select v-model="status" clearable placeholder="请选择" @change="fetchs()" style="min-width: 140px;">
                        <el-option label="草稿" value="0"></el-option>
                        <el-option label="待审核" value="1"></el-option>
                        <el-option label="已审核" value="2"></el-option>
                        <el-option label="已入库" value="3"></el-option>
                        <el-option label="已作废" value="-1"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="入库状态">
                    <el-select v-model="inboundStatus" clearable placeholder="请选择" @change="fetchs()" style="min-width: 140px;">
                        <el-option label="未入库" value="0"></el-option>
                        <el-option label="已入库" value="1"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="" label-width="20px">
                    <el-button type="primary" icon="search" @click="fetchs()">搜索</el-button>
                </el-form-item>
            </el-row>
        </el-form>

        <div class="toolbar">
            <el-button type="primary" icon="Plus" @click="add">新增</el-button>
            <el-button type="danger" icon="Delete" @click="deleter">删除</el-button>
            
            <el-dropdown style="margin-left:20px;">
                <el-button plain type="primary">
                    <el-icon style="margin-right:5px;">
                        <Upload />
                    </el-icon>
                    数据操作
                </el-button>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click="download()">导出列表</el-dropdown-item>
                        <!-- <el-dropdown-item d>生成入库单</el-dropdown-item>
                        <el-dropdown-item>生成退货单</el-dropdown-item> -->
                    </el-dropdown-menu>
                </template>
            </el-dropdown>

            <!-- <el-button type="success" icon="Check" style="margin-left: 80px;">审核</el-button> -->
            <!-- <el-button type="warning" icon="Box" @click="convertToStockIn" style="margin-left: 80px;">生成入库单</el-button> -->
            <!-- <el-button type="info" icon="DocumentDelete">生成退货单</el-button> -->
        </div>

        <basic-table ref="table" class="table" :query="query" @handler="fetchs">
            <template v-slot:toolbar="scope">
                <el-button v-if="scope.row.status !== -1" @click="edit(scope.row)" link size="small" type="primary" icon="Edit">[编辑]</el-button>
                <el-button @click="view(scope.row)" link size="small" type="info" icon="View">[查看]</el-button>
                <delivery-actions :bill="scope.row" link @changed="fetchs" />
            </template>

            <template v-slot:status="scope">
                <el-tag :type="statusColor(scope.row.status)">
                    {{ statusText(scope.row.status) }}
                </el-tag>
            </template>

            <template v-slot:inboundStatus="scope">
                <el-tag :type="scope.row.inboundStatus === 1 ? 'success' : 'info'">
                    {{ scope.row.inboundStatus === 1 ? '已入库' : '未入库' }}
                </el-tag>
            </template>

            <template v-slot:billDate="scope">
                <span>{{ $util.fmtDate(scope.row.billDate, 'yyyy-MM-dd') }}</span>
            </template>

            <template v-slot:deliveryDate="scope">
                <span :style="dateValid(scope.row.deliveryDate) ? 'color: red' : ''" :title="dateValid(scope.row.deliveryDate)?'预计到货日期已逾期':''">{{ scope.row.deliveryDate ? $util.fmtDate(scope.row.deliveryDate, 'yyyy-MM-dd') : '' }}</span>
            </template>

            <template v-slot:receiverDate="scope">
                <span>{{ scope.row.receiverDate ? $util.fmtDate(scope.row.receiverDate, 'yyyy-MM-dd') : '' }}</span>
            </template>
        </basic-table>
    </el-card>
</template>

<script>
import StaticDialog from '@/components/static-dialog.vue'
import BasicTable from '@/components/basic-table.vue'
import DeliveryActions from './DeliveryActions.vue'

export default {
    name: 'PurchaseDeliveryBill',
    components: { StaticDialog, BasicTable, DeliveryActions },
    data() {
        return {
            query: {
                keyword: '',
                columns: [
                    { type: 'index', label: '序号' },
                    { prop: 'billCode', label: '到货单号', sortable: true, searchable: true, width: '160' },
                    { prop: 'externalNo', label: '外部单号',searchable: true, sortable: true, width: '120', showOverflowTooltip: true },
                    { prop: 'billType', label: '单据类型', searchable: true,sortable: true, width: '90', showOverflowTooltip: true },
                    { prop: 'status', label: '状态', type: 'template', width: '80' },
                    { prop: 'inboundStatus', label: '入库状态', type: 'template', width: '90' },
                    { prop: 'companyName', label: '公司',searchable: true, sortable: true, width: '180' },
                    { prop: 'departmentName', label: '部门',searchable: true, sortable: true, width: '80' },
                    { prop: 'supplierName', label: '供应商', searchable: true, sortable: true, width: '120', showOverflowTooltip: true },
                    { prop: 'receiverName', label: '收货人', searchable: true, sortable: true, width: '80' },
                    { prop: 'billDate', label: '制单日期', type: 'template', sortable: true, width: '100' },
                    { prop: 'deliveryDate', label: '预计到货日期', type: 'template', sortable: true, width: '120' },
                    { prop: 'receiverDate', label: '收货日期', type: 'template', sortable: true, width: '100' },
                    { prop: 'totalQuantity', label: '总数量', sortable: true, width: '100' },
                    { prop: 'totalAmount', label: '总金额', sortable: true, width: '120' },
                    { prop: 'totalTaxAmount', label: '含税总额', sortable: true, width: '120' },
                    { prop: 'storeName', label: '收货仓库',searchable: true, sortable: true, width: '140' },
                    { prop: 'remark', label: '备注', width: '160', showOverflowTooltip: true },
                    { type: 'toolbar', label: '操作', width: '360', fixed: 'right' }
                ],
                filters: [],
                sidx: 'billDate',
                sord: 'desc'
            },
            status: '',
            inboundStatus: ''
        }
    },
    mounted() {
        this.$kaung.init(this.$options.name);
        this.fetchs();
    },
    methods: {
        dateValid(date) {
            if (!date) return false;
            // 尝试解析日期
            let targetDate = new Date(date)
            // 如果解析失败（Invalid Date），尝试替换 - 为 /
            if (isNaN(targetDate.getTime()) && typeof date === 'string') {
                targetDate = new Date(date.replace(/-/g, '/'))
            }
            
            // 如果预计到货日期小于当前时间（即已逾期），显示红色
            if (!isNaN(targetDate.getTime()) && targetDate < new Date()) {
                return true;
            }
            return false;
        },
        statusText(s) {
            switch (s) {
                case 0: return '草稿'
                case 1: return '待审核'
                case 2: return '已审核'
                case 3: return '已入库'
                case -1: return '已作废'
                default: return ''
            }
        },
        statusColor(s) {
            switch (s) {
                case 0: return 'info'
                case 1: return 'warning'
                case 2: return 'success'
                case 3: return 'success'
                case -1: return 'danger'
                default: return 'info'
            }
        },

        builder() {
            let { data, records, total, ...params } = { ...this.query };

            // 重置并添加筛选条件
            params.filters = [];
            if (this.status) {
                params.filters.push({ name: "status", value: this.status, operate: 0 });
            }
            if (this.inboundStatus) {
                params.filters.push({ name: "inboundStatus", value: this.inboundStatus, operate: 0 });
            }
            return params;
        },
        fetchs() {
            return this.$kaung.search(this.builder()).then(res => {
                this.query = { ...res.data, columns: (res.data.columns || this.query.columns).map(column =>
                    column.type === 'toolbar' ? { ...column, width: Math.max(Number(column.width) || 0, 360) } : column) }
            })
        },
        download() {
            this.$kaung.export(this.builder()).then(res => {
                this.$notify({ title: '表格数据导出', message: res.content, type: res.type, duration: 10000 })
                window.location.href = process.env.VUE_APP_BASEURL + res.data
            })
        },
        add() {
            this.$router.push({ name: 'PurchaseDeliveryDetail' })
        },
        edit(row) {
            this.$router.push({ name: 'PurchaseDeliveryDetail', query: { id: row.id } })
        },
        view(row) {
            this.$router.push({ name: 'PurchaseDeliveryDetail', query: { id: row.id, mode: 'view' } })
        },
        deleter() {
            if (!this.$refs.table.chooseRow) {
                this.$message({ message: '请点击选择要删除的数据行', type: 'warning' })
                return
            }
            let that = this
            this.$confirm('此操作将删除本页选择数据, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
                .then(() => {
                    this.$kaung.delete(that.$refs.table.chooseRow.id).then(res => {
                        if (res.code === 200) {
                            that.$message({ message: res.content, type: res.type })
                            that.fetchs()
                        }
                    })
                })
        },
    }
}
</script>

<style scoped>
.toolbar {
    margin-bottom: 20px
}

.table {
    margin-top: 10px
}
</style>
